import React,{useContext} from 'react';
import { Link, useLocation } from 'react-router-dom';
import {SITE_TITLE, GetRedirectUrl, INDEX_URL} from '../../settings/common';
import { AppContext } from '../../helpers/AppContext';

const Sidebar = () =>{
	const path = GetRedirectUrl();
	const {isSidebarHidden, setSidebarHidden } = useContext(AppContext);
	const location = useLocation(); // Get the current path

    const isActive = (route) => {
    	if (route === '/chat-list' || route === '/chat') {
            return location.pathname.startsWith('/chat') ? 'active-nav' : '';
        }
        // For other routes, exact match
        return location.pathname === route ? 'active-nav' : '';
    };

    return (
		<React.Fragment>
			{(path !== 'login' && path !== 'sign-up' && path !== '' && path !== null) && (
				<React.Fragment>
					
					<div className={`cx-sidebar-overlay ${isSidebarHidden ? 'cx-sidebar-overlay-hide' : ''}`}></div>
					<div className={`cx-sidebar ${isSidebarHidden ? 'sidebar-hide' : ''}`}>
						<div className="cx-sidebar-head">
							<a href="/" className="logo"><img src={`${process.env.PUBLIC_URL}/assets/image/full-logo.png`} alt="logo"/></a>
						</div>
						<div className="cx-sidebar-body">
							<ul className="cx-sb-list">
								<li className="cx-sb-item sb-drop-item">
									<Link to={"/"} className={`cx-drop-toggle ${isActive('/dashboard')}`}>
										<i className="ri-home-3-line"></i>
										<span className="condense">Dashboard</span>
									</Link>
								</li>

								<li className="cx-sb-item sb-drop-item">
									<a href={"/chat-list"} className={`cx-drop-toggle ${isActive('/chat-list')}`}>
										<i className="ri-message-3-line"></i>
										<span className="condense">Chat List</span>
									</a>
								</li>
							</ul>
						</div>
					</div>
				
				</React.Fragment>
			)}
		</React.Fragment>
       
    );
};

export default Sidebar;